import request from '@/utils/request';
import {newGetPhysicianList} from '@/api/Physicians';

const GATEWAY_PAGE_SIZE = 100;
const MAX_PAGE_COUNT = 10;
const MAX_GATEWAY_PAGE_COUNT = 50;

function uniq(values) {
  return Array.from(new Set((values || []).filter(Boolean).map(item => String(item))));
}

async function fetchPagedGateway(url, params = {}) {
  const result = [];
  let dataCount = 0;

  for (let pageIndex = 1; pageIndex <= MAX_GATEWAY_PAGE_COUNT; pageIndex += 1) {
    const res = await request({
      url,
      method: 'get',
      params: {
        ...params,
        page_index: pageIndex,
        page_size: GATEWAY_PAGE_SIZE,
      },
    });
    const value = res && Array.isArray(res.data) ? res.data : [];
    const currentDataCount = Number(res && res.data_count) || 0;
    if (currentDataCount) dataCount = currentDataCount;
    result.push(...value);
    if (value.length < GATEWAY_PAGE_SIZE || (dataCount && result.length >= dataCount)) {
      break;
    }
  }

  return result;
}

export async function fetchGaAdminTargetCustomers({userId, tas, hcpCategory} = {}) {
  const pageSize = 500;
  const firstParams = {
    user_id: userId,
    page_index: 1,
    page_size: pageSize,
  };
  if (tas) firstParams.tas = tas;
  if (hcpCategory) firstParams.hcp_category = hcpCategory;

  const firstRes = await newGetPhysicianList(firstParams);
  const firstData = firstRes && Array.isArray(firstRes.data) ? firstRes.data : [];
  const dataCount = Number(firstRes && firstRes.data_count) || firstData.length;
  const result = [...firstData];
  const pageCount = Math.min(Math.ceil(dataCount / pageSize), MAX_PAGE_COUNT);

  for (let pageIndex = 2; pageIndex <= pageCount; pageIndex += 1) {
    const params = {...firstParams, page_index: pageIndex};
    const res = await newGetPhysicianList(params);
    if (res && Array.isArray(res.data)) {
      result.push(...res.data);
    }
  }

  return result;
}

export async function fetchGaAdminSubCalls() {
  return fetchPagedGateway('/api/gateway/CRM/GetSubCalls');
}

export async function fetchGaAdminSubCallFeedbacks(callIds = []) {
  const feedbacks = await fetchPagedGateway('/api/gateway/CRM/GetSubCallFeedbacks');
  const callIdSet = new Set(uniq(callIds));
  if (!callIdSet.size) return feedbacks;
  return feedbacks.filter(item => callIdSet.has(String(item.physician_mr_call_id || item.source_msl_call_id || '')));
}
